import styled, { css } from "styled-components";
import { calculateResponsiveSize } from "helpers/calculateResponsiveSize";
import { mediaMax } from "helpers/mediaQueries";
import { Link } from "gatsby";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import ArrwoIcon from "icons/arrow-icon.svg";

export const Wrapper = styled.div`
  display: grid;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
  ${mediaMax("tabletLandscape")} {
    min-height: auto;
    height: 70vh;
  }
`;

export const ImageWrapper = styled.div`
  grid-area: 1/1;
  position: relative;
  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }
  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(30, 30, 30, 0.5);
    transform: rotate(-180deg);
    z-index: 1;
  }
`;

export const Content = styled.div`
  position: relative;
  z-index: 2;
  grid-area: 1/1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  color: #ffffff;
  ${mediaMax("tabletLandscape")} {
    align-items: flex-start;
    padding: 25px 20px;
  }
`;

export const Title = styled(Link)`
  font-size: ${calculateResponsiveSize(96)};
  line-height: 1;
  text-align: center;
  letter-spacing: ${calculateResponsiveSize(-1)};
  font-weight: 400;
  white-space: pre-wrap;
  ${mediaMax("desktopSm")} {
    font-size: 96px;
  }
  ${mediaMax("tabletLandscape")} {
    display: flex;
    justify-content: space-between;
    align-self: flex-start;
    width: 100%;
    width: 100%;
    font-size: 36px;
    line-height: 42px;
    letter-spacing: -0.72px;
    margin-bottom: 24px;
    text-align: left;
  }
  &:after {
    content: "";
    display: block;
    width: ${calculateResponsiveSize(41)};
    height: ${calculateResponsiveSize(24)};
    margin: ${calculateResponsiveSize(16)} auto ${calculateResponsiveSize(36)};
    background-image: url(${ArrwoIcon});
    background-repeat: no-repeat;
    background-size: contain;
    ${mediaMax("desktopSm")} {
      width: 41px;
      height: 24px;
      margin: 16px auto 36px;
    }
    ${mediaMax("tabletLandscape")} {
      width: 31px;
      height: 18px;
      margin: 0;
      align-self: center;
    }
  }
`;

export const Subtitle = styled.h4`
  margin-bottom: ${calculateResponsiveSize(36)};
  font-size: ${calculateResponsiveSize(18)};
  line-height: ${calculateResponsiveSize(22)};
  text-align: center;
  letter-spacing: 0.1em;
  /* font-weight: 600; */
  font-family: "proxima_nova_semibold", san-serif;
  ${mediaMax("desktopSm")} {
    margin-bottom: 36px;
    font-size: 18px;
    line-height: 1;
  }
  ${mediaMax("tabletLandscape")} {
    margin-bottom: 24px;
    font-size: 14px;
    letter-spacing: 1.4px;
  }
`;

export const LinksList = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: 44vw;
  /* text-align: center; */
  justify-content: center;
  ${mediaMax("desktopSm")} {
    max-width: 80vw;
  }
  ${mediaMax("tabletLandscape")} {
    max-width: 100%;
    text-align: left;
    align-items: flex-start;
    flex-direction: column;
    padding-left: 45px;
  }
`;

export const LinkItemStyles = css`
  position: relative;
  display: flex;
  flex-direction: column;
  font-size: ${calculateResponsiveSize(18)};
  line-height: 2;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  /* font-weight: 600; */
  color: #fff;
  text-decoration: none;
  font-family: "proxima_nova_semibold", san-serif;
  margin: 0 ${calculateResponsiveSize(15)} ${calculateResponsiveSize(12)};

  &:before {
    content: "/";
    display: none;
    position: absolute;
    right: ${calculateResponsiveSize(-18)};
    top: 0;
    font-size: ${calculateResponsiveSize(18)};
    line-height: 2;
  }

  &.show-divider:before {
    display: inline-block;
  }

  &::after {
    content: "";
    display: block;
    height: ${calculateResponsiveSize(1)};
    background: #fff;
    width: 0;
    transition: width 1s;
  }
  &:hover {
    &:after {
      width: 100%;
    }
  }
  ${mediaMax("desktopSm")} {
    font-size: 18px;
    margin: 0 15px 12px;
    &:before {
      right: -18px;
      font-size: 18px;
    }
    &:after {
      height: 1px;
    }
  }
  ${mediaMax("tabletLandscape")} {
    font-size: 14px;
    letter-spacing: 1.4px;
    margin: 0 0 20px 0;
    &.show-divider:before {
      display: none;
    }
    &:after {
      display: none;
    }
  }
`;
export const LinkItem = styled(Link)`
  ${LinkItemStyles}
`;

export const AnchorItem = styled(AnchorLink)`
  ${LinkItemStyles}
`;
